
import { useState, useEffect } from 'react';
import { apiClient } from '../utils/api';

export function useWifiData(selectedDevice, selectedInterval, customRange = { start: '', end: '' }) {
    const [wifiData, setWifiData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!selectedDevice || !selectedInterval) {
            setWifiData(null);
            return;
        }

        if (selectedInterval === 'custom') {
            if (!customRange?.start || !customRange?.end) {
                setWifiData(null);
                return;
            }
        }

        const fetchWifiData = async () => {
            try {
                setLoading(true);
                setError(null);

                const extraParams =
                    selectedInterval === 'custom' && customRange?.start && customRange?.end
                        ? { dt_start: customRange.start, dt_end: customRange.end }
                        : undefined;
                const data = await apiClient.getWifiData(selectedDevice, selectedInterval, extraParams);
                setWifiData(data);

            } catch (err) {
                console.error('Error fetching WiFi data:', err);
                if (err?.status === 403) {
                    setError('You do not have permission to view this data.');
                } else if (err?.status === 401) {
                    setError('Session expired. Please sign in again.');
                } else {
                    setError(err.message);
                }
                setWifiData(null);
            } finally {
                setLoading(false);
            }
        };

        fetchWifiData();
    }, [selectedDevice, selectedInterval, customRange?.start, customRange?.end]);

    return { wifiData, loading, error };
}